import React from 'react';
import { Droplets } from 'lucide-react';
import styles from './CupBottomHero.module.css';

const CupBottomHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
  stampLabel = 'Leak Proof',
}) => (
  <section className={styles.heroSection}>
    <div className={styles.inner}>
      <div className={styles.layout}>
        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>{mainTitleLines.join(' ')}</h1>
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureRow}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureChip}>
                  <Droplets size={11} aria-hidden="true" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.baseCol}>
          <div className={styles.baseStage}>
            <span className={styles.cupArc} aria-hidden="true" />
            <span className={styles.sealRing} aria-hidden="true" />
            <span className={styles.sealRingInner} aria-hidden="true" />

            {imagePrimary && (
              <figure className={styles.baseDisc}>
                <img src={imagePrimary.src} alt={imagePrimary.alt} />
              </figure>
            )}

            {imageSecondary && (
              <figure className={styles.satelliteDisc}>
                <img src={imageSecondary.src} alt={imageSecondary.alt} />
              </figure>
            )}

            {stampLabel && (
              <div className={styles.sealBadge}>
                <Droplets size={13} aria-hidden="true" />
                <span>{stampLabel}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CupBottomHero;
